import React from 'react';
import urls from '../configs/urls'
import '../css/App.css';
import ls from 'local-storage'
import axios from 'axios';
import Loading from "./Loading";

class Verify extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            loading: false,
            token : '',
        };
        this.setToken = this.setToken.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }
    componentDidMount() {

    }


    render() {
        return (
            <div className="App">
                <div className="App-body bg-white">
                    <form onSubmit={this.handleSubmit}>
                        <h5 className={"title"}>تایید شماره موبایل</h5>
                        <h6 className={"title2"}>کد ارسال شده را وارد نمایید</h6>
                        <div style={{width:"100%",overflow:"hidden"}}>
                            <input type="number"
                                   pattern="[0-9]*"
                                   value={this.state.token}
                                   onChange={this.setToken}
                                   className={"inputNoBorder"}
                                   placeholder={"کد 5 رقمی"}
                                   style={{float:"right",width:"calc(100% - 150px)",
                                       position:"relative",height:"30px",marginTop:"100px",marginRight:"65px"}}
                            />
                        </div>

                        <input type={"submit"} className={"btn submitPhone"} value={"تایید"}/>

                    </form>
                </div>
                <Loading loading={this.state.loading}/>
            </div>
        );
    }

    setToken(event){
        if (event.target.validity.valid)
            this.setState({token: event.target.value});
    }
    handleSubmit(event){
        event.preventDefault();
        let pattern = /^[0-9]{5}$/;
        if(!pattern.test(this.state.token)) {
            alert("لطفا کد را وارد کنید.");
            return;
        }

        this.sendToken();

    }
    sendToken(){
        this.setState({loading:true});
        let data = {
            phone:ls.get("phone"),
            code:this.state.token,
            city_id:ls.get("city_id"),
            firebase_token:null,
        };
        axios.post(urls.baseUrl+urls.verify,data)
            .then(res => {
                if(res.data.code == 200){
                    ls.set("token",res.data.token);
                    ls.set("city_name",res.data.city_name);
                    this.props.history.push("/home");
                }
                else if(res.data.code == 201){
                    ls.set("token",res.data.token);
                    this.props.history.push("/signup");
                }
                else if(res.data.code == 202){
                    alert(res.data.message);
                    ls.set("token",res.data.token);
                    this.props.history.push("/signup");
                }
                else{
                    this.setState({loading:false});
                    alert(res.data.message);
                }
            })
            .catch(error=>{
                this.setState({loading:false});
                alert(error.toString());
            })
    }
}

export default Verify;
